/* global process */
import Vuex from 'vuex'
import state from './state'
// import * as actions from './actions'
// import * as getters from './getters'
import * as mutations from './mutations'

const debug = process.env.NODE_ENV !== 'production'

// 载入 views 目录下所有文件模块
const modules = require('@utils/requires').requires(require.context('@views', true, /\.store\.js$/))

export default new Vuex.Store({
  state,
  // getters,
  mutations,
  // actions,
  modules: modules,
  strict: debug,
})



// WEBPACK FOOTER //
// ./src/store/index.js